import { ChannelTypes } from '../const';

import { isBrandSearchChannelFn } from './brand-search';
import { isDirectChannelFn } from './direct';
import { isDirectSeoChannelFn } from './direct-seo';
import { isReferralChannelFn } from './referral';
import { isSeoChannelFn } from './seo';
import { isTextChannelFn } from './text';

const detectors = [
  {
    fn: isTextChannelFn,
    channel: ChannelTypes.text,
  },
  {
    fn: isReferralChannelFn,
    channel: ChannelTypes.referral,
  },
  {
    fn: isBrandSearchChannelFn,
    channel: ChannelTypes.brandSearch,
  },
  {
    fn: isSeoChannelFn,
    channel: ChannelTypes.seo,
  },
  {
    fn: isDirectChannelFn,
    channel: ChannelTypes.direct,
  },
  {
    fn: isDirectSeoChannelFn,
    channel: ChannelTypes.directSeo,
  },
];

export default detectors;
